function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import App from 'modules/App';
import { useAction } from 'hooks';
import { CONSENT_MODAL } from 'modules/Mobile/constants';
import { AppContext } from 'context';
import messages from '../../../../messages';
import styles from '../../SignUp.pcss';
export const RegistrationPrivacyMessage = ({ consentUrl })=>{
    const { isAlpineEnabled } = useContext(AppContext);
    const isMobileDisplayMode = useSelector(App.selectors.isMobileDisplayMode);
    const openModal = useAction(App.actions.openModal, CONSENT_MODAL);
    const setStaticFilesDir = useAction(App.actions.setStaticFilesDir);
    const onUrlClickHandler = (e, dir)=>{
        if (isAlpineEnabled === 'true') {
            setStaticFilesDir(dir);
            if (isMobileDisplayMode) {
                openModal();
                e.preventDefault();
            }
        }
    };
    const registrationPrivacyLink = (chunk)=>/*#__PURE__*/ _jsx("a", {
            href: consentUrl,
            target: "_blank",
            onClick: (e)=>onUrlClickHandler(e, App.constants.STATIC_FILES_SETTINGS.POLICY),
            children: chunk
        });
    return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.labels.registrationPrivacy), {
        values: {
            registrationPrivacyLink
        }
    }));
};
export const RegistrationPrivacyFooter = ({ consentUrl })=>/*#__PURE__*/ _jsx("div", {
        className: styles.registrationPrivacy,
        children: /*#__PURE__*/ _jsx(RegistrationPrivacyMessage, {
            consentUrl: consentUrl
        })
    });
